export default __webpack_public_path__ + "5dc527e0a3089d38fc4ab8fd69e2fcbd.svg";